import reduceReducers from 'reduce-reducers'

import { default as CardsReducer } from './cards'
import { default as MemberReducer } from './member'
import { default as PasswordReducer } from './password'
import { default as PolicyReducer } from './policy'
import { default as MemberIdCardReducer } from './memberIdCard'

export * from './cards'
export * from './member'
export * from './password'
export * from './policy'
export * from './memberIdCard'

// Export types and initialState from separate file to avoid circular dependencies
import { types, initialState } from './types'
export { types, initialState }
export default reduceReducers(
  CardsReducer,
  MemberReducer,
  PasswordReducer,
  PolicyReducer,
  MemberIdCardReducer,

  // the last arg MUST be the shared state
  initialState,
)
